import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BookOpen } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  subtitle?: string;
  content: {
    page: string;
    title: string;
    desc?: string;
  }[];
  isOpen: boolean;
  onClick: () => void;
  isBonus?: boolean;
}
export function AccordionItem({
  title,
  subtitle,
  content,
  isOpen,
  onClick,
  isBonus = false
}: AccordionItemProps) {
  return <div className={`border rounded-xl overflow-hidden mb-4 transition-all duration-300 ${isOpen ? 'shadow-md border-green-500' : 'border-gray-200 hover:border-green-300'}`} data-id="element-245">
      <button className={`w-full flex items-center justify-between p-5 text-left transition-colors ${isOpen ? isBonus ? 'bg-amber-50' : 'bg-green-50' : 'bg-white'}`} onClick={onClick} data-id="element-246">
        <div className="flex items-start gap-4" data-id="element-247">
          <div className={`mt-1 p-2 rounded-lg ${isBonus ? 'bg-amber-100 text-amber-600' : 'bg-green-100 text-green-700'}`} data-id="element-248">
            <BookOpen className="w-5 h-5" data-id="element-249" />
          </div>
          <div data-id="element-250">
            <h3 className={`font-bold text-lg md:text-xl ${isBonus ? 'text-amber-900' : 'text-gray-900'}`} data-id="element-251">
              {title}
            </h3>
            {subtitle && <p className="text-sm text-gray-600 mt-1" data-id="element-252">{subtitle}</p>}
          </div>
        </div>
        <div className={`p-2 rounded-full ${isOpen ? isBonus ? 'bg-amber-200 text-amber-700' : 'bg-green-200 text-green-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-253">
          {isOpen ? <ChevronUp className="w-5 h-5" data-id="element-254" /> : <ChevronDown className="w-5 h-5" data-id="element-255" />}
        </div>
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out bg-white ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-256">
        <div className="p-5 border-t border-gray-100" data-id="element-257">
          <ul className="space-y-4" data-id="element-258">
            {content.map((item, index) => <li key={index} className="flex gap-4" data-id="element-259">
                <span className={`text-xs font-bold whitespace-nowrap pt-1 w-16 ${isBonus ? 'text-amber-600' : 'text-green-600'}`} data-id="element-260">
                  {item.page}
                </span>
                <div data-id="element-261">
                  <h4 className="font-semibold text-gray-800" data-id="element-262">{item.title}</h4>
                  {item.desc && <p className="text-sm text-gray-600 mt-0.5" data-id="element-263">{item.desc}</p>}
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}